import { render } from "./inner-open-air.vue?vue&type=template&id=2e80f500"
import script from "./inner-open-air.vue?vue&type=script&lang=js"
export * from "./inner-open-air.vue?vue&type=script&lang=js"

import "./inner-open-air.vue?vue&type=style&index=0&id=2e80f500&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__